// extracted by mini-css-extract-plugin
export default {"Page":"OnboardingPage_Page__WWNWB","Header":"OnboardingPage_Header__SoSPk","OnboardingBlock":"OnboardingPage_OnboardingBlock__TBhAN"};